"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _TableHead = _interopRequireDefault(require("./TableHead.style"));

var _dec, _class;

let TableHead = (_dec = (0, _reactJss.default)(_TableHead.default), _dec(_class = class TableHead extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      columnSize: {}
    };
  }

  componentDidMount() {
    const columnSize = {}; // Делаем один массив если часть tableCell добавляется динамически

    const newChildren = this.props.children.props.children.reduce((acc, e) => acc.concat(e), []);
    newChildren.forEach((item, index) => {
      columnSize[index] = item.props.width;
    });
    this.setState({
      // eslint-disable-line react/no-did-mount-set-state
      columnSize
    });
    this.props.getColumnSize(columnSize);
  }

  render() {
    const {
      columnSize
    } = this.state;
    const {
      className,
      classes,
      children,
      fixed
    } = this.props;
    return _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.tableHead, className, {
        fixed
      })
    }, _react.default.Children.map(children, child => _react.default.cloneElement(child, {
      columnSize
    })));
  }

}) || _class);
TableHead.defaultProps = {
  visibility: 'visible',
  getColumnSize: () => {},
  fixed: false
};
var _default = TableHead;
exports.default = _default;